/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Personal_TitleInputs */

const cs_integrations_personal_title = /** @type {(inputs: Integrations_Personal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní účty`)
};

const en_integrations_personal_title = /** @type {(inputs: Integrations_Personal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal accounts`)
};

/**
* | output |
* | --- |
* | "Personal accounts" |
*
* @param {Integrations_Personal_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_personal_title = /** @type {((inputs?: Integrations_Personal_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Personal_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_personal_title(inputs)
	return cs_integrations_personal_title(inputs)
});